import * as firebase from 'firebase'
import { toUrl } from './text';

let database

export const init = () => {
    if(!firebase.apps.length){
        let config = {
            apiKey: process.env.FIREBASE_API_KEY,
            authDomain: process.env.FIREBASE_AUTH_DOMAIN,
            databaseURL: "https://ferdhika-shop.firebaseio.com",
            projectId: "ferdhika-shop",
            storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID
        }
        
        firebase.initializeApp(config)
        database = firebase.firestore()
        database.settings({
            timestampsInSnapshots: true
        });
    }else{
        firebase.app().firestore()
    }
    
}

// retrieve from firebase
// return promise object
export const getProducts = () => {
    const q = database.collection("produk").orderBy('createdAt', 'desc')

    return q
}

export const getProduct = (docName) => {
    const q = database.collection("produk").doc(docName)

    return q
}

// add new section
export const addProduct = (name, desc, price, size, cat, cover, imgs) => {
    const userRef = database.collection("produk").doc(toUrl(name)).set({
        name: name,
        description: desc,
        size: size,
        price: price,
        category: cat,
        cover: cover,
        images: imgs,
        createdAt: new Date()
    })
    .then(function(docRef) {
        console.log("Document written with ID: ", docRef);
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });  

    return userRef
}


// WEBPACK FOOTER //
// ./src/utils/firebase.js